import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ChangeDetectionStrategy} from '@angular/core';
import {NgbOffcanvas} from '@ng-bootstrap/ng-bootstrap';
import {UntypedFormGroup} from "@angular/forms";

@Component({
    selector: 'jft-revision-conversion-params-modal',
    templateUrl: './revision-conversion-params-modal.component.html',
    styleUrls: ['./revision-conversion-params-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class RevisionConversionParamsModalComponent implements OnInit {
    @Input() public currencies;
    @Input() public customUnits;
    @Input() public conversionFactor;
    @Input() public tender;
    @Input() public previousTender;
    @Input() public baseCurrency;
    @Input() public baseUnit;
    @Input() public includedIndex;
    @Input() public includedMarket;

    @Output() onSetUnitsDefault = new EventEmitter();
    @Output() onSetCustomUnit = new EventEmitter();
    @Output() onUpdateExchangeRates = new EventEmitter();
    @Output() onSetCustomCurrency = new EventEmitter();
    @Output() onBaseCurrencyChange = new EventEmitter();
    @Output() onBaseUnitChange = new EventEmitter();
    @Output() onIncludedIndex = new EventEmitter();
    @Output() onIncludedMarket = new EventEmitter();

    public closeResult: string;
    public form: UntypedFormGroup;
    public modalRef;
    public activeTab: 'units' | 'currencies' | 'comparison' = 'units';

    constructor(
        public offcanvasService: NgbOffcanvas,
    ) {
    }

    ngOnInit() {
    }

    public setUnitsDefault(event) {
        this.onSetUnitsDefault.emit(event);
    }

    public onCustomUnit(event) {
        this.onSetCustomUnit.emit(event);
    }

    public updateExchangeRates(event) {
        this.onUpdateExchangeRates.emit(event);
    }

    public onCustomCurrency(event) {
        this.onSetCustomCurrency.emit(event);
    }

    public baseCurrencyChange(event) {
        this.onBaseCurrencyChange.emit(event);
    }

    public baseUnitChange(event) {
        this.onBaseUnitChange.emit(event);
    }

    public openDisplaySettings(template: TemplateRef<any>) {
        this.modalRef = this.offcanvasService.open(template, {
            position: 'end',
            panelClass: 'bid-h shadow' //w-50  (will be 50% wight on display)
        });
        this.modalRef.result.then(
        );
    }

    public save(event) {

    }

    public onIncludeIndex(value, includedIndex) {
        this.onIncludedIndex.emit(includedIndex);
    }

    public onIncludeMarket(value, includedMarket) {
        this.onIncludedMarket.emit(includedMarket);
    }
}


